/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as GraphDefs from './defs.defs'

const $nsid = 'app.bsky.graph.getListMutes'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params({
  limit: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.withDefault(
      /*#__PURE__*/ l.integer({ maximum: 100, minimum: 1 }),
      50,
    ),
  ),
  cursor: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
})

export type $Params = l.InferOutput<typeof $params>

export const $output = /*#__PURE__*/ l.jsonPayload({
  lists: /*#__PURE__*/ l.array(
    /*#__PURE__*/ l.ref<GraphDefs.ListView>((() => GraphDefs.listView) as any),
  ),
  cursor: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Enumerates mod lists that the requesting account (actor) currently has muted. Requires auth. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output)

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }
